const NOISE = new Set(["NEW", "NOU", "NOUA", "ML", "GR", "G", "L", "LT", "MORPHOSIS", "MEDAVITA", "FRAMESI", "SONO", "LALGA", "MOWAN", "SARYNA", "PENTRU", "PT", "DE", "CU", "SI", "LA", "A", "IN", "THE"]);
const SYN = { SHAMPOO: "SAMPON", SAMPOO: "SAMPON", SHAMPON: "SAMPON", SH: "SAMPON", CONDITIONER: "BALSAM", COND: "BALSAM", CD: "BALSAM", RESTRUCTER: "RESTRUCTURE", MASK: "MASCA", MASCHERA: "MASCA" };

const tokens = (name) => (name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
  .replace(/\b20(2[3-9])\b/g, " ").replace(/(\d+)\s*(ML|GR|G|L)\b/g, "$1").match(/[A-Z0-9]+/g)?.map((w) => SYN[w] || w).filter((w) => !NOISE.has(w)) || [];
const ncode = (c) => String(c || "").toUpperCase().replace(/[\s.\-]/g, "");

// Map product id -> list of other active products of the same brand that look like the same item.
export function findDups(products) {
  const act = products.filter((p) => p.active && p.name?.trim() && !(p.shades || []).length);
  const info = act.map((p) => {
    const t = new Set(tokens(p.name));
    return { p, t, sizes: [...t].filter((w) => /^\d+$/.test(w)).sort().join(","), code: ncode(p.code) };
  });
  const out = {};
  const link = (a, b) => { (out[a.id] ||= []).push(b); (out[b.id] ||= []).push(a); };
  for (let i = 0; i < info.length; i++) {
    for (let j = i + 1; j < info.length; j++) {
      const a = info[i], b = info[j];
      if (a.p.brand !== b.p.brand) continue;
      if (a.code.length >= 4 && a.code === b.code) { link(a.p, b.p); continue; }
      if (a.sizes !== b.sizes || a.t.size < 2 || b.t.size < 2) continue;
      const inter = [...a.t].filter((w) => b.t.has(w)).length;
      if (inter / (a.t.size + b.t.size - inter) >= 0.99) link(a.p, b.p);
    }
  }
  return out;
}
